<template>
  <font-awesome-layers full-width :title="tooltip" class="fa-4x">
    <font-awesome-icon :icon="icon" :class="iconClass" />
    <font-awesome-layers-text :class="textClass" :transform="transform" :value="text" />
  </font-awesome-layers>
</template>

<script setup>
defineProps({
  tooltip: {
    type: String,
    required: false,
    default: ''
  },
  icon: {
    type: Array,
    required: true
  },
  iconClass: {
    type: String,
    required: false,
    default: ''
  },
  text: {
    type: String,
    required: false,
    default: ''
  },
  textClass: {
    type: String,
    required: false,
    default: 'text-white'
  },
  transform: {
    type: String,
    required: false,
    default: ''
  }
})
</script>
